import axios from 'axios';
import { createAction } from 'redux-actions';
import _ from 'lodash';
import { showNotification } from './notification_actions';

const instance = axios.create({
  baseURL: process.env.EVENTVIEWER_SERVER,
});

export const WIX_INSTANCE_PARAMS_BASE = window.location.search || `?${window.location.hash.split('?')[1]}`;
export const WIX_INSTANCE_PARAMS = `${WIX_INSTANCE_PARAMS_BASE}&brand=${window.brand || 'wix'}`;

export const startLoading = createAction('START_LOADING');
export const endLoading = createAction('END_LOADING');
export const fetchUser = createAction('FETCH_USER');
export const fetchSettings = createAction('FETCH_SETTINGS');
export const fetchEvents = createAction('FETCH_EVENTS');
export const fetchTicketSpotEvents = createAction('FETCH_TICKET_SPOT_EVENTS');
export const updateSettings = createAction('UPDATE_SETTING');
export const updateSettingsProp = createAction('UPDATE_SETTING_PROPERTY');
export const filterEventsAction = createAction('FILTER_EVENTS');
export const fetchAccountsAction = createAction('FETCH_ACCOUNTS');
export const fetchAccountAction = createAction('FETCH_ACCOUNT');
export const fetchOrganizers = createAction('FETCH_ORGANIZERS');
export const fetchCalendars = createAction('FETCH_CALENDARS');
export const fetchOrganizationsAction = createAction('FETCH_ORGANIZATIONS');
export const updateUserAction = createAction('UPDATE_USER');
export const fetchNativeEventsAction = createAction('FETCH_NATIVE_EVENTS');
export const updateCampaignAction = createAction('UPDATE_CAMPAIGN');
export const getCampaignsAction = createAction('GET_CAMPAIGNS');
export const syncEverythingAction = createAction('SYNC');
export const openModal = createAction('OPEN_MODAL');
export const closeModal = createAction('CLOSE_MODAL');
export const setJourneySessionId = createAction('SET_JOURNEY_SESSION_ID');

function showErrorNotification(dispatch, { response }) {
  return dispatch(
    showNotification({
      type: 'error',
      message: response && !_.isEmpty(response.data) ? response.data.error : 'Problem connecting to Ticket Spot',
    })
  );
}

export const getSettings = () => (dispatch) => {
  dispatch(startLoading());
  return instance
    .get(`/api/v1/config${WIX_INSTANCE_PARAMS}`)
    .then((res) => {
      dispatch(fetchSettings(res.data));
      dispatch(endLoading());
      return res.data;
    })
    .catch((err) => showErrorNotification(dispatch, err));
};

export const syncEverything = () => (dispatch) =>
  instance
    .post(`/api/v1/wix/sync-all${WIX_INSTANCE_PARAMS}`)
    .then((res) => res.data)
    .catch((err) => showErrorNotification(dispatch, err));

export const getEvents = () => (dispatch) => {
  dispatch(startLoading());
  return instance
    .get(`/api/v1/events${WIX_INSTANCE_PARAMS}`)
    .then((res) => {
      dispatch(fetchEvents(res.data));
      dispatch(endLoading());
      return res.data;
    })
    .catch((err) => showErrorNotification(dispatch, err));
};

export const getTicketSpotEvents = () => (dispatch) =>
  instance
    .get(`/api/v1/ticket-spot-events${WIX_INSTANCE_PARAMS}`)
    .then((res) => {
      dispatch(fetchTicketSpotEvents(res.data));
      return res.data;
    })
    .catch((err) => showErrorNotification(dispatch, err));

export const getNativeEvents = () => (dispatch) => {
  dispatch(startLoading());
  return instance
    .get(`/api/v1/wix/native-events${WIX_INSTANCE_PARAMS}`)
    .then((res) => {
      dispatch(fetchNativeEventsAction(res.data));
      dispatch(endLoading());
      return res.data;
    })
    .catch((err) => showErrorNotification(dispatch, err));
};
export const getOrganizations = () => (dispatch) =>
  instance
    .get(`/api/v1/users/organizations${WIX_INSTANCE_PARAMS}`)
    .then((res) => {
      dispatch(fetchOrganizationsAction(res.data));
      return res.data;
    })
    .catch((err) => showErrorNotification(dispatch, err));

export const updateUser = (id) => (dispatch) =>
  instance
    .put(`/api/v1/users${WIX_INSTANCE_PARAMS}`, { organizationId: id })
    .then((res) => {
      dispatch(updateUserAction(res.data));
      return res.data;
    })
    .catch((err) => showErrorNotification(dispatch, err));

export const createTicketTailorUser = (apiKey) => (dispatch) =>
  instance
    .post(`/api/v1/ticket-tailor/users${WIX_INSTANCE_PARAMS}`, { apiKey })
    .then((res) => {
      getSettings()(dispatch).then(() => dispatch(updateUserAction(res.data)));
      return res.data;
    })
    .catch((err) => showErrorNotification(dispatch, err));

export const createRegFoxUser = (apiKey) => (dispatch) =>
  instance
    .post(`/api/v1/reg-fox/users${WIX_INSTANCE_PARAMS}`, { apiKey })
    .then((res) => {
      getSettings()(dispatch).then(() => dispatch(updateUserAction(res.data)));
      return res.data;
    })
    .catch((err) => showErrorNotification(dispatch, err));

export const createOvationTixUser = (clientId) => (dispatch) =>
  instance
    .post(`/api/v1/ovation-tix/users${WIX_INSTANCE_PARAMS}`, { clientId })
    .then((res) => {
      getSettings()(dispatch).then(() => dispatch(updateUserAction(res.data)));
      return res.data;
    })
    .catch((err) => showErrorNotification(dispatch, err));

export const createTicketSpiceUser = (apiKey) => (dispatch) =>
  instance
    .post(`/api/v1/ticket-spice/users${WIX_INSTANCE_PARAMS}`, { apiKey })
    .then((res) => {
      getSettings()(dispatch).then(() => dispatch(updateUserAction(res.data)));
      return res.data;
    })
    .catch((err) => showErrorNotification(dispatch, err));

export const updateTicketSpiceUser = (widgetHtml) => (dispatch) =>
  instance
    .put(`/api/v1/ticket-spice/users${WIX_INSTANCE_PARAMS}`, { widgetHtml })
    .then((res) => {
      getSettings()(dispatch).then(() => dispatch(updateUserAction(res.data)));
      return res.data;
    })
    .catch((err) => showErrorNotification(dispatch, err));

export const filterEvents = (filterType, values) => (dispatch) => {
  dispatch(filterEventsAction({ filterType, values }));
};

export const createEvent = () => (dispatch) =>
  instance.post(`/api/v1/events${WIX_INSTANCE_PARAMS}`).catch((err) => showErrorNotification(dispatch, err));

export const getUser = () => (dispatch) =>
  instance
    .get(`/api/v1/users/${WIX_INSTANCE_PARAMS}`)
    .then((res) => {
      dispatch(fetchUser(res.data));
      return res.data;
    })
    .catch(() => dispatch(fetchUser({})));

export const getAccounts = () => (dispatch) =>
  instance
    .get(`/api/v1/connected-accounts/${WIX_INSTANCE_PARAMS}`)
    .then((res) => {
      dispatch(fetchAccountsAction(res.data));
      return res.data;
    })
    .catch(() => dispatch(fetchAccountsAction({})));

export const getAccount = () => (dispatch) =>
  instance
    .get(`/api/v1/dashboard/accounts/${WIX_INSTANCE_PARAMS}`)
    .then((res) => {
      dispatch(fetchAccountAction(res.data));
      return res.data;
    })
    .catch(() => dispatch(fetchAccountAction({})));

export const getGoogleUser = (id) => (dispatch) => {
  if (!id) {
    return Promise.resolve();
  }
  return instance
    .get(`/api/v1/google-users${WIX_INSTANCE_PARAMS}`)
    .then((res) => {
      dispatch(fetchUser(res.data));
      return res.data;
    })
    .catch(() => dispatch(fetchUser({})));
};

export const getOrganizers = () => (dispatch) =>
  instance
    .get(`/api/v1/events/organizers${WIX_INSTANCE_PARAMS}`)
    .then((res) => {
      dispatch(fetchOrganizers(res.data));
      return res.data;
    })
    .catch((err) => showErrorNotification(dispatch, err));

export const getCalendars = () => (dispatch) =>
  instance
    .get(`/api/v1/config/google/calendars${WIX_INSTANCE_PARAMS}`)
    .then((res) => {
      dispatch(fetchCalendars(res.data));
      return res.data;
    })
    .catch((err) => showErrorNotification(dispatch, err));

export const publish = () => instance.post(`/api/v1/publish${WIX_INSTANCE_PARAMS}`);

export const updateSettingsState = (key, value) => (dispatch) => {
  dispatch(updateSettingsProp({ key, value }));
};

export const updateSettingsProperty = (key, value) => (dispatch) =>
  instance
    .put(`/api/v1/config${WIX_INSTANCE_PARAMS}`, { [key]: value })
    .then(() => {
      dispatch(updateSettingsProp({ key, value }));
    })
    .catch((err) => {
      Raven.captureException(err, { instance: Wix.Utils.getInstanceId() });
      return showErrorNotification(dispatch, err);
    });
export const updateCampaign = (id, data) => (dispatch) =>
  instance
    .put(`/api/v1/campaigns/${id}${WIX_INSTANCE_PARAMS}`, data)
    .then(() => {
      dispatch(updateCampaignAction(data));
    })
    .catch((err) => {
      Raven.captureException(err, { instance: Wix.Utils.getInstanceId() });
      return showErrorNotification(dispatch, err);
    });

export const getCampaigns = (id, data) => (dispatch) =>
  instance
    .get(`/api/v1/campaigns/${WIX_INSTANCE_PARAMS}`, data)
    .then(() => {
      dispatch(getCampaignsAction(data));
    })
    .catch((err) => {
      Raven.captureException(err, { instance: Wix.Utils.getInstanceId() });
      return showErrorNotification(dispatch, err);
    });

export const disconnect = (key, value) => (dispatch) =>
  instance
    .put(`/api/v1/config/disconnect${WIX_INSTANCE_PARAMS}`, { [key]: value })
    .then(() => {
      dispatch(updateSettingsProp({ key, value }));
    })
    .catch((err) => {
      Raven.captureException(err, { instance: Wix.Utils.getInstanceId() });
      return showErrorNotification(dispatch, err);
    });

export const updateSettingsPropertyBulk = (data) => (dispatch) =>
  instance
    .put(`/api/v1/config${WIX_INSTANCE_PARAMS}`, data)
    .then(() => {
      dispatch(updateSettingsProp(data));
    })
    .catch((err) => {
      Raven.captureException(err, { instance: Wix.Utils.getInstanceId() });
      return showErrorNotification(dispatch, err);
    });

export const deleteComponent = () => instance.delete(`/config${WIX_INSTANCE_PARAMS}`);

export const verifyUser = () => (dispatch) =>
  instance
    .put(`/api/v1/config/user_validate${WIX_INSTANCE_PARAMS}`, {}, { withCredentials: true })
    .then(({ data }) => getSettings()(dispatch).then(() => dispatch(fetchUser(data))));
export const verifyGoogleUser = () => (dispatch) =>
  instance
    .put(`/api/v1/config/google_user_validate${WIX_INSTANCE_PARAMS}`, {}, { withCredentials: true })
    .then(({ data }) => getSettings()(dispatch).then(() => dispatch(fetchUser(data))));

export const deleteSettings = () => instance.delete(`/api/v1/config${WIX_INSTANCE_PARAMS}`);
